var installedModules = {};
var moduleToHandlerMapping = {
	72902: {
		getter: function() { return __webpack_require__.e(893).then(function() { return function() { return __webpack_require__(62893); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "2.6.14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "vue",
	},
	50962: {
		getter: function() { return __webpack_require__.e(706).then(function() { return function() { return __webpack_require__(18706); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "2.13.6",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "vant",
	},
	90402: {
		getter: function() { return __webpack_require__.e(893).then(function() { return function() { return __webpack_require__(62893); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^2.5.2",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "vue",
	},
	27567: {
		getter: function() { return __webpack_require__.e(893).then(function() { return function() { return __webpack_require__(62893); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "*",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "vue",
	},
	21705: {
		getter: function() { return __webpack_require__.e(893).then(function() { return function() { return __webpack_require__(62893); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^2.0.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "vue",
	},
	49587: {
		getter: function() { return __webpack_require__.e(93).then(function() { return function() { return __webpack_require__(95093); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "2.30.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "moment",
	},
	24724: {
		getter: function() { return __webpack_require__.e(173).then(function() { return function() { return __webpack_require__(40173); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "3.5.3",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "vue-router",
	},
	14754: {
		getter: function() { return __webpack_require__.e(543).then(function() { return function() { return __webpack_require__(2543); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "4.17.21",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "lodash",
	},
	70950: {
		getter: function() { return __webpack_require__.e(893).then(function() { return function() { return __webpack_require__(62893); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": ">= 2.6.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "vue",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"453": [
		72902,
		50962,
		90402,
		27567,
		21705,
		49587,
		24724,
		14754
	],
	"706": [
		70950
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}